import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const DeleteProjectFolderPopup = loadAsyncComponent(() => import('./Container'), 'popup');
